import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    SAVE_APPOINTMENT_NOT_ATTENDED_STATUS,
    saveAppointmentNotAttendedStatusFail,
    saveAppointmentNotAttendedStatusSuccess
} from '../action/saveAppointmentNotAttendedStatusAction'

// api 
import saveAppointmentNotAttendedStatusApi from '../api/saveAppointmentNotAttendedStatusApi'

export function* saveAppointmentNotAttendedStatusSaga(action) {

    try {
        const response = yield call(() => saveAppointmentNotAttendedStatusApi(action.params))
        if (response.data.status === 1) {
            yield put(saveAppointmentNotAttendedStatusSuccess(response, action))
        } else {
            yield put(saveAppointmentNotAttendedStatusFail(response, action))
        }
    }
    catch (e) {
        yield put(saveAppointmentNotAttendedStatusFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(SAVE_APPOINTMENT_NOT_ATTENDED_STATUS, saveAppointmentNotAttendedStatusSaga)
}